import OperationTypes from "../../types";
import { AutoCompleteOption } from "./AutoComplete";

export const nameof = <T>(name: keyof T) => name;

export type FlattenObject<
  T extends Record<string, unknown>,
  Key = keyof T
> = Key extends string
  ? T[Key] extends Record<string, unknown>
    ? `${Key}.${FlattenObject<T[Key]>}`
    : `${Key}`
  : never;

export const domains2AutocompleteOptions = (domainList: OperationTypes.Domain[], key: keyof OperationTypes.Domain, value: keyof OperationTypes.Domain): AutoCompleteOption[] => {
  return domainList.map((dom) => ({
    value: dom[key],
    label: dom[value],
  })) || [];
}

